// extracted by mini-css-extract-plugin
export default {"input":"xja-z","button":"yja-z","selected":"zja-z","sephoraImage":"Aja-z","unavailable":"Bja-z","image":"Cja-z"};